import { AlarmLevel } from "../models/metMap/forecastResult";
import PowMonLimit from "../models/metMap/powmon/powmonLimit";
import { PQ4castDataType } from "../models/metMap/pQ4castDataType";
import FormatUtil from "../utils/formatUtil";
import ScaleLogic from "./scaleLogic";
class PowMon {
    static mpointIds() {
        return [...new Set(PowMon.mpointPowerGroups.map(m => m.mpointId))];
    }
    static mpointIdsProd() {
        return [...new Set(PowMon.mpointPowerGroupsProd.map(m => m.mpointId))];
    }
    static setScale(pVal) {
        PowMon.scaleFactor = ScaleLogic.preferredScale(pVal);
    }
    static formatP(val) {
        return FormatUtil.fValue(val, PQ4castDataType.Ptot, PowMon.scaleFactor);
    }
    static formatQ(val) {
        return FormatUtil.fValue(val, PQ4castDataType.Qtot, PowMon.scaleFactor);
    }
    static scaledUnitP() {
        return ScaleLogic.unitScaled("W", PowMon.scaleFactor);
    }
    static scaledUnitQ() {
        return ScaleLogic.unitScaled("VAr", PowMon.scaleFactor);
    }
    static scale(val) {
        return ScaleLogic.valueScaled(val, PowMon.scaleFactor);
    }
    static alarmLevelP(val) {
        if (val >= PowMon.levelMax)
            return AlarmLevel.AboveMax;
        if (val >= PowMon.level2)
            return AlarmLevel.Alarm;
        if (val >= PowMon.level1)
            return AlarmLevel.Warning;
        return AlarmLevel.OK;
    }
    static alarmLevelQ(val) {
        if (val >= PowMon.levelQMax || val <= PowMon.levelQMin)
            return AlarmLevel.Alarm;
        return AlarmLevel.OK;
    }
    static pLimits() {
        return [{ name: 'Warning', limit: this.level1 }, { name: 'Alarm', limit: this.level2 }, { name: 'Max', limit: this.levelMax }]
            .filter(l => l.limit)
            .map(l => new PowMonLimit(PQ4castDataType.Ptot, l.limit, PowMon.alarmLevelP(l.limit), l.name));
    }
    static qLimits() {
        return [{ name: 'Min', limit: this.levelQMin }, { name: 'Max', limit: this.levelQMax }]
            .filter(l => l.limit)
            .map(l => new PowMonLimit(PQ4castDataType.Qtot, l.limit, PowMon.alarmLevelQ(l.limit), l.name));
    }
    static scaleLimit(limit) {
        limit.limit = PowMon.scale(limit.limit);
        return limit;
    }
}
PowMon.level1 = NaN;
PowMon.level2 = NaN;
PowMon.levelMax = NaN;
PowMon.levelQMax = NaN;
PowMon.levelQMin = NaN;
PowMon.scaleFactor = 1;
PowMon.noOfPrognosisMinutes = 15;
PowMon.mpointPowerGroups = [];
PowMon.mpointPowerGroupsProd = [];
PowMon.showProduction = false;
export default PowMon;
